import type { FC } from 'react';
import React from 'react';
import { MDText } from 'i18n-react';

import { Toggle } from '@motorway/mw-highway-code/alpha';

import useAccountRouter from 'Components/Account/useAccountRouter';
import cypressIds from 'Components/cypress_ids.json';
import { applyCypressData } from 'Utilities/helpers';

import LocalTexts from '../../../../Filters.texts';

import { triggerDeliveredToggleSnowplowEvent } from './DeliveredToggle.helpers';

const LocalT = new MDText(LocalTexts);

const DeliveredToggle: FC = () => {
	const { changePage, hideDelivered } = useAccountRouter();

	const handleGAEvent = () => {
		triggerDeliveredToggleSnowplowEvent(hideDelivered);
	};

	return (
		<Toggle
			formProps={{
				input: {
					...applyCypressData(cypressIds.buttons.purchasesCompleteDeliveredFilter),
					checked: hideDelivered,
					name: 'hideDelivered',
					onChange: () => {
						changePage({ hideDelivered: String(!hideDelivered) });
						handleGAEvent();
					},
					type: 'checkbox',
				},
			}}
			id="delivered-toggle"
			label={LocalT.translate(`deliveredToggle.heading`)}
			showLabel={true}
		/>
	);
};

export default DeliveredToggle;
